/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */

import PlanComponent from './main';

export const plan = (context, next) => {
    context.primary = <PlanComponent />;
    next();
};
